module.exports = __webpack_public_path__ + "img/energy_transporter.f88870d2.png";